import React, { ReactNode } from 'react';

import Button from '@liquidweb-dev/undercurrent/Button';
import EmptyState, {
	EmptyStateProps,
} from '@liquidweb-dev/undercurrent/EmptyState';
import CircleX from '@liquidweb-dev/undercurrent/icons/lucide/CircleX';
import RotateCwIcon from '@liquidweb-dev/undercurrent/icons/lucide/RotateCw';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface ErrorStateProps extends EmptyStateProps {
	onTryAgain?: () => void;
	children?: ReactNode;
}

const ErrorState = ({ onTryAgain, sx, children, ...rest }: ErrorStateProps) => (
	<EmptyState
		icon={
			<CircleX
				sx={combineSx({
					height: ({ size }) => size.md,
					width: ({ size }) => size.md,
					color: ({ vars }) => vars.palette.uc.danger.icon.main,
				})}
			/>
		}
		primaryButton={
			onTryAgain && (
				<Button startIcon={<RotateCwIcon />} size="large" onClick={onTryAgain}>
					Try again
				</Button>
			)
		}
		sx={combineSx({ maxWidth: '264px' }, sx)}
		{...rest}
	>
		{children || "We're having trouble loading this data right now"}
	</EmptyState>
);

export default ErrorState;
